import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as G } from "react";
import { c as K } from "./index-DkZ16bcJ.mjs";
import { l as M } from "./lodash-5ofSKtz3.mjs";
import { T as $ } from "./text-field-ZOMRKQAY.mjs";
import { A as z, D as Q, a as Y, b as Z, c as V } from "./autocomplete-n7dpskro.mjs";
import { m as T } from "./tss-DN0acMKN.mjs";
import { f as n } from "./index-LyFokDcn.mjs";
import { _ as ee } from "./composeRefs-YONvD-rx.mjs";
import { I as te } from "./X10x10-Bso1Otyr.mjs";
function oe(t = "") {
  if (t)
    return `${t}-autocomplete-single-input`;
}
const le = T()(() => ({
  root: {
    "& .MuiInputBase-root": {
      display: "flex",
      flexWrap: "wrap",
      padding: "0 24px 0 0"
    }
  },
  input: {
    lineHeight: "21px"
  }
})), re = T()(({ palette: t }) => ({
  clearIcon: {
    alignItems: "center",
    display: "flex",
    fill: t.gray[500],
    justifyContent: "center",
    "&:hover": {
      fill: t.gray[700]
    }
  }
}));
function ne({
  afterLabel: t,
  allowAnyInputValue: s = !1,
  ariaDescribedby: h,
  autoHighlight: E = !1,
  apiRef: I,
  biId: i,
  /* @startCleanup encore */
  classes: a = {},
  /* @endCleanup encore */
  containerRef: g,
  disabled: A = !1,
  errorMessage: y,
  filterSelectedOptions: L = !1,
  getOptionLabel: f,
  groupBy: F,
  hasPopupToggle: O = !1,
  id: S,
  inputProps: l,
  inputRef: _,
  inputValue: b,
  label: j,
  labelPlacement: P,
  note: v,
  notePlacement: C,
  loading: D = !1,
  loadingText: B = V,
  onChange: N,
  placeholder: U,
  renderGroup: X,
  renderInput: c,
  required: u = !1,
  size: d,
  status: R,
  value: p,
  variant: m,
  warningMessage: W,
  ...w
}, H) {
  const { classes: x } = le(), { classes: J } = re(), k = (e) => {
    if (typeof f == "function") {
      const r = f(e);
      return r || "";
    }
    return typeof e == "string" ? e : "";
  };
  return /* @__PURE__ */ o.jsx(
    z,
    {
      ...w,
      autoHighlight: E,
      autoSelect: !1,
      blurOnSelect: !1,
      classes: n.ifFeature("encore", void 0, {
        ...a,
        root: K(x.root, a.root)
      }),
      clearIcon: n.ifFeature(
        "encore",
        void 0,
        /* @__PURE__ */ o.jsx("div", { className: J.clearIcon, children: /* @__PURE__ */ o.jsx(te, {}) })
      ),
      clearOnBlur: !s,
      clearOnEscape: !1,
      clearText: Q,
      closeOnSelect: !0,
      closeText: Y,
      "data-fabric-component": "AutocompleteSingle",
      disabled: A,
      disableListWrap: !1,
      disablePortal: !1,
      filterSelectedOptions: L,
      fullWidth: !0,
      getOptionLabel: k,
      groupBy: F,
      handleHomeEndKeys: !0,
      hasClearButton: !0,
      hasPopupToggle: O,
      id: S,
      includeInputInList: !!s,
      inputValue: b,
      isAnyInputValueAllowed: s,
      loading: D,
      loadingText: B,
      multiple: !1,
      onChange: q,
      openOnFocus: !1,
      openText: Z,
      ref: ee(H, g),
      renderGroup: X,
      renderInput: (e) => (e.inputProps = M.merge(e.inputProps, l, {
        required: !!(l != null && l.required || u)
      }), e.inputProps["data-bi-id"] = oe(i), e.placeholder = U, c ? c(e) : /* @__PURE__ */ o.jsx("div", { ref: e.InputProps.ref, children: /* @__PURE__ */ o.jsx(
        $,
        {
          afterLabel: t,
          apiRef: I,
          ariaDescribedby: h,
          biId: i,
          disabled: e.disabled,
          errorMessage: y,
          id: e.id,
          InputLabelProps: e.InputLabelProps,
          InputProps: n.ifFeature("encore", e.InputProps, { ...e.InputProps, className: x.input }),
          inputProps: e.inputProps,
          label: j,
          labelPlacement: P,
          note: v,
          notePlacement: C,
          placeholder: p ? void 0 : e.placeholder,
          ref: _,
          required: u,
          size: d,
          status: R,
          variant: m,
          warningMessage: W,
          width: 100
        }
      ) })),
      selectOnFocus: !1,
      size: n.ifFeature("encore", d, "small"),
      value: p,
      variant: m
    }
  );
  function q(e, r) {
    e.value === null && (e.value = ""), N(e, r);
  }
}
const Te = G(ne);
export {
  Te as A
};
//# sourceMappingURL=autocomplete-single-DLiRLl1T.mjs.map
